import request from 'superagent';

export default function markAsRead(user, design) {
    request
        .post(design.links.markAsReadComments)
        .set('X-Csrf-Token', user.tokens[0].mark_as_read_comment)
        .timeout(10000)
        .end();
}



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/actions/mark-as-read.js